// extracted by mini-css-extract-plugin
export var card = "_74-0";
export var expandedCard = "_74-2";
export var paginated = "_74-1";